module.exports = __webpack_public_path__ + "static/img/loginlogo.bd6b17f.png";